

















































































































































import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";

import rtSelect from "@/components/activityManagement/rtSelect.vue";
import rtDatePicker from "@/components/activityManagement/rtDatePicker.vue";
import { Toast } from "vant";

const activityManagementModule = namespace("activityManagement");

@Component({
	components: {
		rtSelect,
		rtDatePicker,
	},
})
export default class ActivityManagement extends Vue {
	activtyStatusList: { label: string; value: any }[] = [
		{ label: "全部", value: null },
		{ label: "待配置", value: 0 },
		{ label: "进行中", value: 1 },
		{ label: "暂停", value: 2 },
		{ label: "已结束", value: 3 },
		{ label: "待启动", value: 4 },
		{ label: "已废弃", value: 5 },
		{ label: "待审核", value: 6 },
	];

	activityStatusVisible: boolean = false;
	activityStatus: any = 1;
	get activityStatusDesc(): string {
		const statusObj: any = this.activtyStatusList.find(
			(item) => item.value == this.activityStatus
		);
		if (statusObj) return statusObj.label;
		return "全部";
	}
	get activityStatusDataList(): string[] {
		return this.activtyStatusList.map((item) => item.label);
	}

	activityName: string = ""; /* 输入搜索 */
	activityStartDate: string = ""; //活动有效时间

	selfStatus: boolean = false;
	finished: boolean = false;
	pages: any = {
		finished: false,
		loading: false,
		total: 0,
		pageNum: 1,
		pageSize: 10,
		activityList: [],
	};

	ruleVisible: boolean = false;
	ruleList: { label: string; value: any; type:boolean }[] = [];

	mounted() {
		(this as any).$wechartfunc();
		Toast.clear();
	}
	async getActivityList(pageNum?: number) {
		this.pages.loading = true;
		const { error, success }: any = await this.$request(
			"SIGNUP_ACTIVITY_LIST",
			{
				activityName: this.activityName,
				activityStartDate: this.activityStartDate,
				activityStatus: this.activityStatus,
				pageNum: pageNum || this.pages.pageNum,
				pageSize: this.pages.pageSize,
			}
		);
		this.pages.loading = false;
		if (success) {
			this.pages.total = success.data.total;
			if (this.pages.pageNum >= success.data.pages) {
				this.finished = true;
			}
			this.pages.pageNum = this.pages.pageNum + 1;
			this.pages.activityList = [
				...(this.pages.activityList || []),
				...(success.data.list || []).map((item: any) => {
					item.activityStartDate = this.$format(
						item.activityStartDate
					);
					item.activityEndDate = this.$format(item.activityEndDate);
					return item;
				}),
			];
		}
	}
	handleActivityDate(value: string) {
		this.activityStartDate = value;
		this.pages.pageNum = 1;
		this.renderGetData();
	}
	onSearch(item: string) {
		this.activityName = item;
		this.pages.pageNum = 1;
		this.renderGetData();
	}
	input(item: string) {
		this.activityName = item;
		this.pages.pageNum = 1;
		this.renderGetData();
	}
	onActivityStatusCancel() {
		this.activityStatusVisible = false;
	}
	onActivityStatusConfirm(value: any, index: number) {
		this.pages.pageNum = 1;
		this.activityStatus = this.activtyStatusList[index].value;
		this.activityStatusVisible = !this.activityStatusVisible;
		this.renderGetData();
	}
	renderGetData() {
		this.pages.activityList = [];
		this.selfStatus = true;
		this.getActivityList();
		this.selfStatus = false;
	}
	onLoadList() {
		this.getActivityList();
	}
	async onScanClick(activityId: string) {
		const memberCardNo: string = await (this as any).$wechartfunc(
			"scanQRCode"
		);
		// const memberCardNo: string = "00002474443268";
		console.log(memberCardNo)
		if (memberCardNo) {
			this.$router.push(
				`/activitySign/info/${memberCardNo}/${activityId}`
			);
		} else {
			Toast.fail("扫码失败, 请重试!");
		}
	}
	async onRuleClick(activityId: string) {
		Toast.loading({ duration: 0, forbidClick: true });
		const {
			error,
			success,
		}: any = await this.$request("SIGNUP_ACTIVITY_INFO", { activityId });
		Toast.clear();

		if (error) {
			this.$toast({
				type: "fail",
				message: error.msg || error.message,
			});
		}
		if (success) {
			const data: any = success.data;
			this.ruleList = [];
			this.ruleList.push({ label: "活动名称: ", value: "",type:false });
			this.ruleList.push({ label: "", value: data.name || "-" ,type:false});
			this.ruleList.push({
				label: "活动时间: ",
				value: "",
				type:false
			});
			this.ruleList.push({
				label: "",
				value:
					this.$format(data.activityStartDate) +
					" 至 " +
					this.$format(data.activityEndDate) +
					` (${data.activityStatusDesc})`,
				type:false
			});

			this.ruleList.push({ label: "活动规则: ", value: "",type:false });
			let price:string = data.conditionType
						? `近${
								data.conditionDay
							}天消费总额需达到${(this as any).$currency(
								data.conditionPrice / 100
							)}元`
						: "不限消费金额",

					memberPoint = (this as any).$thousand(data.memberPoint == 0) 
						? '可免费参与活动' : `需消耗${data.memberPoint}积分参与活动`,

					perDayLimit = data.perDayLimit == 0 
						? '每人每天不限参与次数' : `每人每天最多参与${data.perDayLimit}次`,

					perCumulativeLimit = data.perCumulativeLimit == 0 
						? '每人累计不限参与次数' : `每人累计最多参与${data.perCumulativeLimit}次`

			let ruleText1:string = '全部会员,' + price + ',' + memberPoint + ',' + perDayLimit + ',' + perCumulativeLimit

			const gradeRuleList: any[] = data.gradeRuleList || [];
			const ruleTextArr:any = []
			if (gradeRuleList.length) {
				gradeRuleList.forEach((item: any) => {
					let member:string = item.memberCardName,
					price2 = item.conditionType
						? `近${
								item.conditionDay
							}天消费总额需达到${(this as any).$currency(
								item.conditionPrice / 100
							)}元`
						: "不限消费金额",

					memberPoint2 = (this as any).$thousand(item.memberPoint == 0) 
						? '可免费参与活动' : `需消耗${item.memberPoint}积分参与活动`,

					perDayLimit2 = item.perDayLimit == 0 
						? '每人每天不限参与次数' : `每人每天最多参与${item.perDayLimit}次`,

					perCumulativeLimit2 = item.perCumulativeLimit == 0 
						? '每人累计不限参与次数' : `每人累计最多参与${item.perCumulativeLimit}次`
					
					const ruleText2:string = member + ',' + price2 + ',' + memberPoint2 + ',' + perDayLimit2 + ',' +perCumulativeLimit2
					ruleTextArr.push(ruleText2)
				});
			}
			// console.log( data.isAllMember,ruleText1 , ruleTextArr)
			this.ruleList.push({
				label:"",
				value: data.isAllMember == 1 ? ruleText1 :  ruleTextArr,
				type:data.isAllMember == 1 ? false : true
			});

			this.ruleVisible = true;
		}
	}
}
